import {
    HttpResponse,
    MachineComponentWorkplaceModel,
    RequestParams,
    ApiResultFailed,
    Operation,
    AggregationModel,
    AggregationResponse,
    GrouppedQueryModel
} from "@/libs/Api";
import ApiService from "@/libs/core/api-service"
import {CrudDataQuery, CrudService} from '@/libs/core/+state/models/crud-service';
import {CrudEnumerableResponse, CrudResponse} from "../core/+state/models/crud-response";

export class MachineComponentWorkplacesDataService implements CrudService<MachineComponentWorkplaceModel, MachineComponentWorkplaceModel> {
    getAll(query: CrudDataQuery<MachineComponentWorkplaceModel>): Promise<CrudEnumerableResponse<MachineComponentWorkplaceModel>> {
        return ApiService.api.getMachineComponentWorkplaceBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    getBasicAll(query: CrudDataQuery<MachineComponentWorkplaceModel>): Promise<CrudEnumerableResponse<MachineComponentWorkplaceModel>> {
        throw new Error('NotImplemented');
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<MachineComponentWorkplaceModel>> {
        return ApiService.api.getMachineComponentWorkplaceById(id, params);
    }

    create(item: MachineComponentWorkplaceModel, params?: RequestParams): Promise<CrudResponse<MachineComponentWorkplaceModel>> {
        return ApiService.api.insertMachineComponentWorkplace(item, params);
    }

    update(item: MachineComponentWorkplaceModel, params?: RequestParams): Promise<MachineComponentWorkplaceModel> {
        return ApiService.api.updateMachineComponentWorkplace(item.id as Required<string>, item, params).then((req: any) => req.data.returnValue);
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<MachineComponentWorkplaceModel> {
        return ApiService.api.patchMachineComponentWorkplace(id, patches, params).then((req: any) => req.data.returnValue);
    }

    delete(query: CrudDataQuery<MachineComponentWorkplaceModel>): Promise<CrudEnumerableResponse<MachineComponentWorkplaceModel>> {
        return ApiService.api.deleteMachineComponentWorkplaces(<any>query.data, query.params).then((req: any) => req.data.returnValue);
    }

    getAggregation(query: AggregationModel, params?: RequestParams): Promise<AggregationResponse> {
        return ApiService.api.aggregationMachineComponentWorkplace(query, params).then((req: any) => req.data.returnValue);
    }

    download(query: CrudDataQuery<MachineComponentWorkplaceModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        throw new Error('NotImplemented');
    }

    clone(item: MachineComponentWorkplaceModel, params?: RequestParams): Promise<CrudResponse<MachineComponentWorkplaceModel>> {
        throw new Error('NotImplemented');
    }

    getGroupped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        return ApiService.api.getMachineComponentWorkplaceGroupped(query, params);
    }

}

